import { render } from "./Navbar.vue?vue&type=template&id=47682c76"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=47682c76&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__